import { ApiClientError, isApiError, type ApiErrorBody } from "./types";

type ApiListResult<T> =
  | { ok: true; data: T[]; meta?: Record<string, unknown> }
  | ApiErrorBody;

type ApiDataResult<T> = { ok: true; data: T } | ApiErrorBody;

export function unwrapApiList<T>(res: ApiListResult<T>): T[] {
  if (isApiError(res)) {
    throw new ApiClientError(
      res.error.message,
      400,
      res.error.code,
      res.error.reason,
    );
  }
  return res.data;
}

export function unwrapApiData<T>(res: ApiDataResult<T>): T {
  if (isApiError(res)) {
    throw new ApiClientError(
      res.error.message,
      400,
      res.error.code,
      res.error.reason,
    );
  }
  return res.data;
}
